import { render, staticRenderFns } from "./AdminNotification.vue?vue&type=template&id=2b23ea32&"
import script from "./AdminNotification.vue?vue&type=script&lang=js&"
export * from "./AdminNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports